export const GlobalVariable = {

    razor_pay_key: 'rzp_live_YmyxdRilAgKlpK', // test key :rzp_test_dvfpRNEUlLTuCq,  live : rzp_live_YmyxdRilAgKlpK

}